module.exports = __webpack_public_path__ + "static/img/lick.8de47e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lick.png
// module id = h99Y
// module chunks = 0